// const LIVE_API_ORIGIN = 'https://api.bandhanguru.com';
const LIVE_API_ORIGIN = 'https://api.bandhanguru.com';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || `${LIVE_API_ORIGIN}/api`;

export const API_IMAGE_BASE_URL =
  process.env.REACT_APP_IMAGE_BASE_URL || LIVE_API_ORIGIN;
